import request from '@/utils/request'

export function tbSharedQuery(data) { //共享设备 - 查询
    return request({
        method: 'get',
        url: 'tbShared/query',
        params: data
    })
}
export function tbSharedQueryById(data) { //共享设备 - 查询
    return request({
        method: 'get',
        url: 'tbShared/query/'+data,
    })
}

export function tbSharedAdd(data) { //共享设备 - 新增
    return request({
        method: 'post',
        url: 'tbShared/add',
        data
    })
}

export function tbSharedDelete(data) { //共享设备 - 删除
    return request({
        method: 'get',
        url: 'tbShared/delete/'+data,
    })
}